import { render, staticRenderFns } from "./Managermessages-manual.vue?vue&type=template&id=6dbbc9ca&"
import script from "./Managermessages-manual.vue?vue&type=script&lang=js&"
export * from "./Managermessages-manual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports